"use client"

import type { ButtonHTMLAttributes, FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"
import { useState, useEffect, useRef } from "react"

import { Button } from "@jobteaser/spark/components/Button"
import { Menu } from "@jobteaser/spark/components/Icons/Menu"

import { UserAvatar } from "@/modules/dashboard/components/UserAvatar/UserAvatar"

import dropdownMenuStyles from "@/modules/headerFooterFO/Header/styles/DropdownMenu.module.css"

type DropdownUserButtonProps = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    avatarUrl?: string | null
  }
>

export const DropdownUserButton: FunctionComponent<DropdownUserButtonProps> = ({ avatarUrl, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement | null>(null)

  const handleOnClick = (): void => {
    setIsOpen(prev => !prev)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  return (
    <Button
      {...props}
      aria-expanded={isOpen}
      className={clsx(dropdownMenuStyles["hdr-DropdownMenu-userButton"])}
      onClick={handleOnClick}
      ref={buttonRef}
      size="small"
      type="button"
      variant="secondary"
    >
      <UserAvatar className={dropdownMenuStyles["hdr-DropdownMenu-avatar"]} size={32} src={avatarUrl || ""} />
      <Menu className={dropdownMenuStyles["hdr-DropdownMenu-linkMenuIcon"]} size={20} />
    </Button>
  )
}
